<template>
  <AppSection top>
    <AppContainer>
      <BlogBreadcrumbs :current="name" />
      <h1 class="pt-5">
        {{ $tt('blog.author') }}: {{ name }}
      </h1>
      <ArticleCards v-if="posts" :posts :columns="3" has-excerpt />
    </AppContainer>
  </AppSection>
</template>

<script setup lang="ts">
import { getAuthorName } from '~/helpers/blog';

const author = +useRoute().params.author;
const { getPosts } = useWordpress();
const { data: posts } = await useAsyncData(() => getPosts({ author }));
const name = getAuthorName(posts.value![0]);
useHead({ title: name });
</script>